import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: '"Lexend", sans-serif',
    h1: {
      fontFamily: '"Lexend", sans-serif',
    },
    h2: {
      fontFamily: '"Lexend", sans-serif',
    },
    h3: {
      fontFamily: '"Lexend", sans-serif',
    },
    h4: {
      fontFamily: '"Lexend", sans-serif',
    },
    h5: {
      fontFamily: '"Lexend", sans-serif',
    },
    h6: {
      fontFamily: '"Lexend", sans-serif',
    },
    subtitle1: {
      fontFamily: '"Lexend", sans-serif',
    },
    subtitle2: {
      fontFamily: '"Lexend", sans-serif',
    },
    body1: {
      fontFamily: '"Lexend", sans-serif',
    },
    body2: {
      fontFamily: '"Lexend", sans-serif',
    },
    button: {
      fontFamily: '"Lexend", sans-serif',
    },
    caption: {
      fontFamily: '"Lexend", sans-serif',
    },
    overline: {
      fontFamily: '"Lexend", sans-serif',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: '"Lexend", sans-serif',
        },
      },
    },
  },
});

export default theme;
